export default __webpack_public_path__ + "static/1 - Új villamoshálózat kialakítása-5dfc4af6d14a752903f1e80d325aaf3a.jpg";